var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-small right blue-grey darken-1",attrs:{"value":_vm.value},on:{"change":function($event){return _vm.onChange($event.target.value)}}},[_c('i',{staticClass:"material-icons small"},[_vm._v("create")])])
}
var staticRenderFns = []

export { render, staticRenderFns }